import { getDefinitionFromPath } from '@helpers/routeDefinitions';
import { useMixpanel } from '@hooks/useMixpanel';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export default function MainLayout() {
    const mixpanel = useMixpanel();
    const location = useLocation();

    const isSandboxEnv = window.location.href.includes('sandbox');

    useEffect(() => {
        if (isSandboxEnv) {
            const link = window.location.origin.replace('sandbox-', '');
            window.location.href = `${link}${location.pathname}`;
        }
    }, []);

    useEffect(() => {
        const pageDefinition = getDefinitionFromPath(location.pathname + location.hash);

        if (pageDefinition?.mixpanelName)
            mixpanel?.track(pageDefinition.mixpanelName);
    }, [location]);

    return <Outlet />;
}
